import { createAction, props } from '@ngrx/store';

export const setReferenceInputsAction = createAction(
  '[REFERENCEINPUTS] Set REFERENCEINPUTS',
  props<{ referenceInputs: any }>()
);